// @flow
import React from 'react';
import { ContactPage } from '../components/contact-us';

export const ContactUsView = () => (
  <div>
    <ContactPage />
  </div>
);
